jQuery(document).ready(function($) {

  /* Load More Posts
  ---------------------------------------- */
  $(document).on( 'click', '.ajax-load-more', function( event ) {
    event.preventDefault();

    var $btn     = $(this);
    var paged    = $btn.data('page') ? parseInt($btn.data('page')) : 2;
    var template = $btn.data('template') ? $btn.data('template') : '';

    $.ajax({
      url: ajax_object.ajaxurl,
      type: 'post',
      data: {
        action:     'load_more_posts',
        query_vars: ajax_object.query_vars,
        page:       paged,
        template:   template
      },
      success: function(respons) {
        if (respons.success) {

          // Append HTML
          var html = respons.data.html;
          $('.ajax-container').append(html);

          // Increase page to load counter
          $btn.data('page', ++paged);

          // Hide load more button if last element
          if (respons.data.last) { $btn.remove(); }

        }
      }
    });
  });

});
